export default "__VITE_ASSET__55408333__"